/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { AnswerCorrectIcon, AnswerWrongIcon } from '@coursera/cds-icons';

import { useCoachSuggestionContext } from 'bundles/ai-coach-platform/components/patterns/suggestions/context/coachSuggestionContext';
import { ResolutionStatus } from 'bundles/ai-coach-platform/components/patterns/suggestions/types';

const styles = {
  resolveIcon: css`
    display: flex;
  `,
};

type Props = {};

export type CoachSuggestionStatusComponent = React.ReactElement<Props>;

const CoachSuggestionStatus = () => {
  const { status } = useCoachSuggestionContext();
  return (
    <div css={styles.resolveIcon}>
      {status === ResolutionStatus.ACCEPTED && <AnswerCorrectIcon color="success" />}
      {status === ResolutionStatus.REJECTED && <AnswerWrongIcon color="error" />}
    </div>
  );
};

export default CoachSuggestionStatus;
